{
  "sign_in": "Kirjaudu sisään",
  "sign_up": "Rekisteröidy",
  "no_account_question": "Eikö sinulla ole tunnuksia?",
  "register_here": "Rekisteröidy tästä",
  "have_account_question": "Onko sinulla jo tunnukset?",
  "sign_in_here": "Kirjaudu sisään",
  "or_divider": "TAI",
  "login_with_ebirdie": "Kirjaudu eBirdiellä",
  "login_with_google": "Kirjaudu Googlella",
  "login_with_apple": "Kirjaudu Applella",
  "forgot_password_question": "Unohditko salasanasi?",
  "reset_password_action": "Palauta salasana",
  "signing_in": "Kirjaudutaan sisään...",
  "signing_up": "Rekisteröidytään...",
  "minimum_8_characters": "Vähintään 8 merkkiä",
  "forgot_password": "Unohditko salasanan?",
  "continue_with": "tai jatka palvelulla",
  "continue_with_google": "Google",
  "already_have_account": "Onko sinulla jo tili?",
  "dont_have_account": "Eikö sinulla ole tiliä?",
  "completing_login": "Viimeistellään kirjautumista...",
  "oauth_login_failed": "Kirjautuminen epäonnistui",
  "missing_auth_tokens": "Tunnistautumistokenit puuttuvat",
  "auth_successful_but_failed_load": "Tunnistautuminen onnistui, mutta käyttäjätietojen lataaminen epäonnistui",
  "authentication_failed": "Tunnistautuminen epäonnistui",
  "enter_email_for_reset": "Syötä sähköpostiosoitteesi, niin lähetämme sinulle linkin salasanan palauttamiseksi.",
  "send_reset_email": "Lähetä palautuslinkki",
  "sending_reset_email": "Lähetetään palautuslinkkiä...",
  "password_reset_sent": "Salasanan palautuslinkki lähetetty onnistuneesti",
  "check_your_email": "Tarkista sähköpostisi",
  "password_reset_instructions": "Olemme lähettäneet salasanan palautuslinkin sähköpostiisi. Tarkista postilaatikkosi ja napsauta linkkiä palauttaaksesi salasanasi.",
  "back_to_login": "Takaisin kirjautumiseen",
  "reset_password": "Palauta salasana",
  "enter_new_password": "Syötä uusi salasanasi alle.",
  "new_password": "Uusi salasana",
  "confirm_new_password": "Vahvista uusi salasana",
  "confirm_password": "Vahvista salasana",
  "resetting_password": "Palautetaan salasanaa...",
  "password_reset_success": "Salasana palautettu onnistuneesti",
  "invalid_or_expired_token": "Virheellinen tai vanhentunut tunniste",
  "invalid_reset_link": "Virheellinen palautuslinkki",
  "validating_reset_link": "Tarkistetaan linkkiä...",
  "reset_link_expired_or_invalid": "Palautuslinkki on vanhentunut tai virheellinen. Pyydä uusi palautuslinkki.",
  "request_new_reset_link": "Pyydä uusi palautuslinkki",
  "password_reset_complete": "Salasanan palautus valmis",
  "password_reset_complete_message": "Salasanasi on palautettu onnistuneesti. Voit nyt kirjautua sisään uudella salasanallasi.",
  "continue_to_login": "Jatka kirjautumiseen",
  "complete_profile_title": "Täydennä profiilisi",
  "username": "Käyttäjänimi",
  "username_required": "Käyttäjänimi vaaditaan",
  "username_length": "Käyttäjänimen tulee olla 3-50 merkkiä",
  "username_invalid": "Käyttäjänimi voi sisältää vain kirjaimia, numeroita ja alaviivoja",
  "username_taken": "Tämä käyttäjänimi on jo käytössä",
  "checking_availability": "Tarkistetaan saatavuutta...",
  "first_name": "Etunimi",
  "first_name_required": "Etunimi on pakollinen",
  "last_name": "Sukunimi",
  "last_name_required": "Sukunimi on pakollinen",
  "handicap": "Tasoitus",
  "handicap_invalid": "Tasoituksen tulee olla välillä -10 ja 54",
  "gender": "Sukupuoli",
  "gender_not_specified": "Ei määritelty",
  "gender_male": "Mies",
  "gender_female": "Nainen",
  "gender_other": "Muu",
  "complete_profile_button": "Täydennä profiili",
  "completing_profile": "Täydennetään profiilia...",
  "profile_completed": "Profiili täydennetty onnistuneesti!",
  "profile_completion_error": "Profiilin täydentäminen epäonnistui. Yritä uudelleen.",
  "registration_successful": "Rekisteröinti onnistui!",
  "account_deleted_successfully": "Tili poistettu onnistuneesti",
  "account_deletion_failed": "Tilin poistaminen epäonnistui",
  "verifying_email": "Vahvistetaan sähköpostiosoitetta...",
  "please_wait": "Odota hetki, kun vahvistamme sähköpostiosoitteesi.",
  "verification_success": "Sähköposti vahvistettu!",
  "verification_failed_title": "Vahvistus epäonnistui",
  "redirecting": "Ohjataan sinut hetken kuluttua...",
  "verify_email_title": "Tarkista sähköpostisi",
  "verify_email_message": "Lähetimme vahvistuslinkin osoitteeseen",
  "verification_link_expires": "Vahvistuslinkki vanhenee 24 tunnin kuluttua. Jos et näe sähköpostia, tarkista roskapostikansiosi.",
  "go_to_login": "Siirry kirjautumiseen",
  "email_change": {
    "confirming": "Vahvistetaan sähköpostiosoitteen vaihtoa...",
    "success_title": "Sähköpostiosoite vaihdettu",
    "go_to_app": "Siirry sovellukseen",
    "failed_title": "Vahvistus epäonnistui"
  },
  "login_failed": "Kirjautuminen epäonnistui",
  "too_many_attempts": "Liian monta kirjautumisyritystä. Yritä myöhemmin uudelleen.",
  "ebirdie_username": "Suomi Golf ID -tunnus",
  "ebirdie_username_placeholder": "Suomi Golf ID -tunnus tai sähköposti",
  "ebirdie_invalid_credentials": "Virheelliset Golf ID -tunnukset",
  "ebirdie_service_unavailable": "Golf ID -palveluun ei saada yhteyttä. Yritä myöhemmin uudelleen.",
  "ebirdie_login_failed": "Golf ID -kirjautuminen epäonnistui",
  "ebirdie_fetch_title": "Tietojen nouto eBirdiestä",
  "ebirdie_fetch_description": "Rekisteröityessäsi tietosi (nimi, ikä, seura, jäsennumero ja tasoitus) haetaan automaattisesti Suomen Golfliiton eBirdie järjestelmästä.",
  "ebirdie_accept_terms": "Hyväksyn ehdot"
}
